import React from "react";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => (
  <div className={`h-3 rounded bg-gray-200 animate-pulse ${className}`} />
);

export const WordBankTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={index} className="text-center odd:bg-white even:bg-gray-50">
          {Array.from({ length: 12 }).map((__, cellIndex) => (
            <td key={`${index}-${cellIndex}`} className="px-2 py-3 sm:px-4 border-t border-gray-200">
              {cellIndex === 1 ? (
                <div className="flex justify-center">
                  <div className="h-6 w-24 rounded-full bg-gray-200 animate-pulse" />
                </div>
              ) : cellIndex === 4 || cellIndex === 5 || cellIndex === 6 || cellIndex === 8 ? (
                <div className="flex justify-center">
                  <div className="h-5 w-20 rounded-full bg-gray-200 animate-pulse" />
                </div>
              ) : cellIndex === 9 || cellIndex === 10 ? (
                <div className="space-y-2">
                  <Cell className="w-20 mx-auto" />
                  <Cell className="w-14 mx-auto" />
                </div>
              ) : cellIndex === 11 ? (
                <div className="flex justify-center">
                  <div className="h-9 w-10 rounded-lg bg-gray-200 animate-pulse" />
                </div>
              ) : (
                <Cell className="w-24 mx-auto" />
              )}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default WordBankTableSkeleton;
